import { Slide } from '../../SlideComponents/slide.types';

export const LOADING_SLIDE_ID = '1583915166083';
export const LOADING_ELEMENT_ID = 'loading-element-static-id';

export const LOADING_SLIDE: Slide = {
  contextElements: [],
  dataReferenceSlideId: null,
  durationSeconds: null,
  elements: [
    {
      angle: 0,
      borderRadius: 0,
      height: 1080,
      id: LOADING_ELEMENT_ID,
      opacity: 1,
      type: 'loader',
      version: 1,
      width: 1920,
      x: 0,
      y: 0,
    },
  ],
  generatorId: 'dynamicLesson',
  height: 1080,
  id: '1583915166083',
  type: 'slide',
  version: 1,
  width: 1920,
};
